<template>
  <div class="format-time-input">
    <input
      ref="inputDom"
      v-model="time"
      type="tel"
      @focus="focus"
      @blur="blur"
      @keydown="keydown($event)"
      @mousedown="mousedown"
      @mousemove.prevent.stop
      @dblclick.prevent
      @click.prevent
    >
    <div class="add-plus-content">
      <div class="add-plus-btn">
        <span @mousedown.prevent="addPlus(1)">
          <iconfont
            class="normal-format"
            name="#icon11-110xuanzeshang"
            font-size="8px"
          ></iconfont>
          <iconfont
            class="hover-format"
            name="#icon11-110xuanzeshangjiaohu"
            font-size="8px"
          ></iconfont>
        </span>
        <span @mousedown.prevent="addPlus(-1)">
          <iconfont
            class="normal-format"
            name="#icon11-111xuanzexia"
            font-size="8px"
          ></iconfont>
          <iconfont
            class="hover-format"
            name="#icon11-111xuanzexiajiaohu"
            font-size="8px"
          ></iconfont>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    priTime: {
      type: Number,
      default: 0
    },
    limitType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      time: '00:00.0',
      minute: '00',
      secound: '00',
      points: 0,
      pos: '',
      focusing: false,
      cache: 0
    };
  },
  watch: {
    priTime() {
      this.initData();
    }
  },
  mounted() {
    this.$bus.on('formatTimeInput.init', this.initData);
  },
  beforeDestroy() {
    this.$bus.off('formatTimeInput.init', this.initData);
  },
  methods: {
    initData() {
      this.timeToFormat(this.priTime);
      this.getTime();
    },
    timeToFormat(time) {
      let points = Math.floor(time * 10) % 10;
      let minute = Math.floor(time / 60);
      let secound = Math.floor(time - minute * 60);
      this.minute = this.completion(minute);
      this.secound = this.completion(secound);
      this.points = points;
    },
    completion(val) {
      return val.toString().padStart(2, 0);
      // let s = val.toString();
      // if (s.length === 0) {
      //   return '00';
      // } else if (s.length === 1) {
      //   return '0' + s;
      // } else {
      //   return s;
      // }
    },
    getTime() {
      this.time = `${this.minute}:${this.secound}.${this.points}`;
    },
    focus(e) {
      // 取消默认选中
      this.focusing = true;
      this.$nextTick(() => {
        let s = window.getSelection();
        if (s.rangeCount > 0) s.removeAllRanges();
      });
      this.$emit('focus', e);
    },
    mouseupFunc(e) {
      // 点击事件
      this.cache = ''; // 清除缓存数字
      this.selectChange(e);
    },
    keydown(e) {
      // 阻止默认事件
      e.preventDefault();
      e.stopPropagation();
      console.log(e, '<-----------12');
      let code = e.code;
      let key = e.key;
      if (key === 'Unidentified' || this.time.length !== 7) {
        this.changeTime();
        return;
      }

      this.selectChange(e);

      if (code.indexOf('Digit') > -1 || code.indexOf('Numpad') > -1) {
        if (code === 'NumpadDecimal') return;
        let num = code.slice(code.length - 1);
        if (isNaN(num)) return;
        this.keyNumber(num);
        return;
      }

      let k = e.keyCode;
      if (k === 40) {
        // down
        this.keyDownUp(-1);
      } else if (k === 38) {
        this.keyDownUp(1);
      } else if (k === 37) {
        // left
        if (this.pos === 'points') {
          this.setSelect(3, 5, 'secound');
        } else if (this.pos === 'secound') {
          this.setSelect(0, 2, 'minute');
        }
        this.cache = '';
      } else if (k === 39) {
        if (this.pos === 'secound') {
          this.setSelect(6, 7, 'points');
        } else if (this.pos === 'minute') {
          this.setSelect(3, 5, 'secound');
        }
        this.cache = '';
      } else if (k === 46 || k === 8) {
        // 删除
        if (this.pos === 'minute') {
          this.minute = '00';
          this.changeTime(0, 2);
        } else if (this.pos === 'secound') {
          this.secound = '00';
          this.changeTime(3, 5);
        } else if (this.pos === 'points') {
          this.points = 0;
          this.changeTime(6, 7);
        }
        // 删除也得情况cache
        this.cache = '';
      }
    },
    keyDownUp(val) {
      let s = window.getSelection();
      let v = +s.toString();
      if (isNaN(v)) v = 0;
      v = v + val;
      if (this.pos === 'points') {
        if (isNaN(v)) {
          this.points = 0;
        } else if (v < 0) {
          this.points = 9;
        } else if (v > 9) {
          this.points = 0;
        } else {
          this.points = v;
        }
        this.changeTime(6, 7);
      } else if (this.pos === 'secound') {
        if (v < 0 || v > 59 || isNaN(v)) return;
        this.secound = this.completion(v);
        this.changeTime(3, 5);
      } else if (this.pos === 'minute') {
        if (v < 0 || v > 59 || isNaN(v)) return;
        this.minute = this.completion(v);
        this.changeTime(0, 2);
      }
      this.cache = '';
    },
    keyNumber(key) {
      // 以下情况清空缓存
      if (this.cache.length > 1) {
        this.cache = '';
      } else {
        if (+this.cache > 5 || this.cache === '0') {
          this.cache = '';
        }
      }

      this.cache = this.cache + key;

      if (this.pos === 'minute') {
        this.minute = this.completion(this.cache);
        this.changeTime(0, 2);
      } else if (this.pos === 'secound') {
        this.secound = this.completion(this.cache);
        this.changeTime(3, 5);
      } else if (this.pos === 'points') {
        // 小数位不需要cache
        this.cache = '';
        this.points = +key;
        this.changeTime(6, 7);
      }
    },
    changeTime(start, end) {
      this.getTime();
      this.$nextTick(() => {
        this.$refs.inputDom.setSelectionRange(start, end);
      });
    },
    setSelect(start, end, type) {
      this.$refs.inputDom.setSelectionRange(start, end);
      type && (this.pos = type);
    },
    selectChange(e) {
      let end = this.$refs.inputDom.selectionEnd;
      let start = this.$refs.inputDom.selectionStart;
      if (end >= 6) {
        if (this.pos === 'points' && start === 6) {
          e.preventDefault();
          return;
        }

        let s = window.getSelection();
        if (s.rangeCount > 0) s.removeAllRanges();
        this.setSelect(6, 7, 'points');
      } else if (end < 6 && end >= 3) {
        if (this.pos === 'secound' && start === 3) {
          e.preventDefault();
          return;
        }

        let s = window.getSelection();
        if (s.rangeCount > 0) s.removeAllRanges();
        this.setSelect(3, 5, 'secound');
      } else if (end < 3) {
        if (this.pos === 'minute' && start === 0) {
          e.preventDefault();
          return;
        }

        let s = window.getSelection();
        if (s.rangeCount > 0) s.removeAllRanges();
        this.setSelect(0, 2, 'minute');
      }
    },
    reSelect() {
      if (this.pos === 'points') {
        this.changeTime(6, 7);
      } else if (this.pos === 'secound') {
        this.changeTime(3, 5);
      } else if (this.pos === 'minute') {
        this.changeTime(0, 2);
      }
    },
    addPlus(val) {
      if (!this.pos) {
        this.$refs.inputDom.focus();
        let s = window.getSelection();
        if (s.rangeCount > 0) s.removeAllRanges();
        this.setSelect(6, 7, 'points');
      }
      this.keyDownUp(val);
    },
    blur() {
      let v = Number(this.minute) * 60 + Number(this.secound) + this.points / 10;
      this.getTime();
      this.pos = '';
      this.$emit('blur', { type: this.limitType, val: v });
    },
    mousedown() {
      document.addEventListener('mouseup', this.mouseupDoc);
    },
    mouseupDoc(e) {
      document.removeEventListener('mouseup', this.mouseupDoc);
      this.cache = ''; // 清除缓存数字
      this.selectChange(e);
    }
  }
};
</script>
<style lang="scss" scoped>
.format-time-input {
  position: relative;
  background: #ffffff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  width: 120px;
  height: 40px;
  text-align: center;
  overflow: hidden;
  box-sizing: border-box;

  input {
    width: 100%;
    height: 100%;
    line-height: 40px;
    padding-left: 18px;
    letter-spacing: 1px;
    font-size: 14px;
  }
}
.add-plus-content {
  position: absolute;
  top: 0;
  right: 9px;
  height: 100%;
}

.add-plus-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  > span {
    width: 18px;
    height: 36%;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    &:first-child {
      align-items: flex-end;
      margin-top: -1px;
    }

    &:last-child {
      margin-top: 2px;
    }

    .hover-format {
      display: none;
    }

    &:hover {
      .normal-format {
        display: none;
      }
      .hover-format {
        display: block;
      }
    }
  }
}

@media (max-width: 1600px) {
  .format-time-input {
    width: 84px;
    height: 30px;

    input {
      line-height: 30px;
      padding-left: 10px;
      font-size: 12px;
    }
  }
  .add-plus-content {
    right: 5px;
  }
  .add-plus-btn {
    > span {
      width: 12px;

      &:first-child {
        align-items: flex-end;
        margin-top: 0px;
      }

      &:last-child {
        margin-top: 0px;
      }

      > svg {
        transform-origin: center;
        transform: scale(0.8);
      }
    }
  }
}
</style>
